import React from 'react';
import { BsCaretDownFill, BsCaretRightFill } from "react-icons/bs";
import { FaPills, FaIndustry, FaBoxes, FaDollarSign } from "react-icons/fa";

const MedicineKPI = ({ 
  totalMedicines, 
  manufacturers, 
  categories, 
  avgPrice,
  showKPIs,
  setShowKPIs 
}) => {
  const formatNumber = (value) => {
    if (typeof value === 'number') {
      return value.toLocaleString();
    }
    return value;
  };

  const kpiCards = [
    { 
      title: 'Total', 
      value: totalMedicines,
      icon: <FaPills />, 
      iconColor: '#f5f2e8'
    },
    { 
      title: 'Manufacturers', 
      value: manufacturers,
      icon: <FaIndustry />, 
      iconColor: '#e8f4fd'
    },
    { 
      title: 'Categories', 
      value: categories,
      icon: <FaBoxes />, 
      iconColor: '#fde8f4'
    },
    { 
      title: 'Avg Price', 
      value: `$${avgPrice}`,
      icon: <FaDollarSign />, 
      iconColor: '#e8f5e8'
    }
  ];

  return (
    <>
      {/* <div className="d-flex align-items-center justify-content-between mb-3 mt-4">
        <div className="d-flex align-items-center">
          <h5 className="mb-0 me-3">Dashboard / Medicines</h5>
          <button 
            onClick={() => setShowKPIs(!showKPIs)} 
            className="btn text-primary p-0"
          >
            {showKPIs ? 'Hide KPIs ' : 'Show KPIs '}
            {showKPIs ? <BsCaretDownFill size={12} /> : <BsCaretRightFill size={12} />}
          </button>
        </div>
      </div> */}
      
      {showKPIs && (
        <div className="row gy-3 introbx_row">
          {kpiCards.map((kpi, index) => (
            <div key={index} className="col">
              <div className="d-flex align-items-center gap-2 p-3 rounded-10 shadow-sm">
                <div className="icon flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle" style={{ width: '2rem', height: '2rem', backgroundColor: '#E4E4FF', color: '#8381FF' }}>
                  <span className="d-block material-symbols-outlined fs-lg">{kpi.icon}</span>
                </div>
                <div className="info flex-fill">
                  <p className="fs-sm text-gray mb-0">{kpi.title}</p>
                  <p className="lh-1 fw-semibold">{formatNumber(kpi.value)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default MedicineKPI;